import "./App.css";

import Navbar from "./Components/Navbar/NavBar";
import TopView from "./Components/TopView/TopView";
import Hero from "./Pages/Home/Hero/Hero";
import Collabs from "./Pages/Home/Collabs/Collabs";
import WorkCard from "./Pages/Home/WorkCard/WorkCard";
import Portfolio from "./Pages/Home/Portfolio/Portfolio";
import Testimonials from "./Pages/Home/Testimonials/Testimonials";
import PricingCard from "./Pages/Home/PricingCard/PricingCard";
import Team from "./Pages/Home/Team/Team";
import FAQSection from "./Pages/Home/FAQs/FAQs";
import JoinUs from "./Pages/Home/Join/JoinUs";
import Footer from "./Components/Footer/Footer";
import Careers from "./Pages/Careers/Careers";
import ContactUs from "./Pages/ContactUs/ContactUs";
import PricingPage from "./Pages/Pricing/Pricing";
import Services from "./Pages/Services/Services";
import PortfolioPage from "./Pages/Portfolio/Portfolio";
import DetailPricing from "./Pages/Home/PricingCard/DetailPricing/DetailPricing";
import DetailPortfolio from "./Pages/Home/Portfolio/DetailPortfolio/DetailPortfolio";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
    <BrowserRouter>
      <Navbar />
      <TopView />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Collabs />
              <WorkCard />
              <Portfolio />
              <Testimonials />
              <PricingCard />
              <Team />
              <FAQSection />
              <JoinUs />
            </>
          }
        />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/pricing/:planId" element={<DetailPricing />} />
        <Route path="/portfolio/:projectId" element={<DetailPortfolio />} />
        <Route path="/careers" element={<Careers />} />
      </Routes>
      <Footer />
    </BrowserRouter>
    
    <ToastContainer
        position="top-right"
        autoClose={3000}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="dark"
      />
    </>
  );
}

export default App;